var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.34,
    height: 32,
    viewBox: "0 0 256 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M64 384c35.328 0 64-28.672 64-64v-64H64c-35.328 0-64 28.672-64 64s28.672 64 64 64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M0 192c0-35.328 28.672-64 64-64h64v128H64c-35.328 0-64-28.672-64-64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M0 64C0 28.672 28.672 0 64 0h64v128H64C28.672 128 0 99.328 0 64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M128 0h64c35.328 0 64 28.672 64 64s-28.672 64-64 64h-64z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M256 192c0 35.328-28.672 64-64 64s-64-28.672-64-64s28.672-64 64-64s64 28.672 64 64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.c30b92b71b429aa7b33468f3f569f500.svg";
export { ForwardRef as ReactComponent };